import { render, staticRenderFns } from "./VasionCompareDocument.vue?vue&type=template&id=56b376fb&scoped=true"
import script from "./VasionCompareDocument.vue?vue&type=script&lang=js"
export * from "./VasionCompareDocument.vue?vue&type=script&lang=js"
import style0 from "./VasionCompareDocument.vue?vue&type=style&index=0&id=56b376fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b376fb",
  null
  
)

export default component.exports